import React, { useState, useEffect } from 'react';
import {
    Form,
    Col,
    Row,
    Card,
} from 'antd';

import * as adminactions from "store/actions/AuthActions";
import DraggerBox from 'components/DraggerBoxTable/DraggerBox';


const DocumentForm = () => {
    const [documentCategoryId, setDocumentCategoryId] = useState(null);

    useEffect(() => {
        const fetchCategory = async () => {
            const categoryId = await adminactions.getDocumentCategoryByCode('DOCUMENT');
            setDocumentCategoryId(categoryId);
        };
        fetchCategory();
    }, []);

    return (
        <>
            <Form
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 18 }}
            >
                <Row
                    style={{ margin: "15px" }}
                >
                    <Col span={24} style={{}}>
                        <div className="site-card-border-less-wrapper">
                            <Card title="Details" bordered={false} style={{}}>
                                <DraggerBox categoryId={documentCategoryId} />
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Form>
        </>
    );
};
export default DocumentForm;